<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="24">
          <el-card class="box-card" v-if="attendee.customer">
            <div class="card-header">
              <h4 class="card-title">
                Letter Of Reference for {{ attendee.customer.firstname }}
                {{ attendee.customer.lastname }}
              </h4>
            </div>

            <div class="card-content">

            <p>Dear Sir/Madam,</p>

            <p>
              This letter is in reference to the performance of
              {{ attendee.customer.firstname }}
              {{ attendee.customer.lastname }} on the TEFL course provided by
              The TEFL Org.
            </p>

        
            <h5>What has {{ attendee.customer.firstname }} learnt?</h5>
            <ul class="list-unstyled">
              <li>
                They have demonstrated
                <select v-model="lor.learnt">
                  <option value="1" label="enthusiasm">enthusiasm</option>
                  <option value="2" label="a positive attitude"
                    >a positive attitude</option
                  >
                  <option value="3" label="interest in the coursework"
                    >interest in the coursework</option
                  >
                </select>
              </li>
              <li>
               They have demonstrated
                <select v-model="lor.demonstrated">
                  <option value="4" label="excellent">excellent</option>
                  <option value="5" label="good">good</option>
                  <option value="6" label="reasonable">reasonable</option>
                </select>
                application to the tasks.
              </li>

              <li>
                I believe they will be
                <select v-model="lor.believe">
                  <option value="7" label="an excellent">an excellent</option>
                  <option value="9" label="a good">a good</option>
                  <option value="10" label="an effective">an effective</option>
                </select>
                teacher with
                <select v-model="lor.support">
                  <option value="11" label="little">little</option>
                  <option value="13" label="some">some</option>
                </select>
                support necessary.
              </li>
              <li>
                They have achieved
                <select v-model="lor.understanding">
                  <option value="14" label="a developing">a developing</option>
                  <option value="9" label="a good">a good</option>
                  <option value="7" label="an excellent"
                    >an excellent</option
                  > </select
                >understanding of issues in EFL.
              </li>
              <li>
              Their lesson planning is
                <select v-model="lor.planning">
                  <option value="4" label="first-rate">first-rate</option>
                  <option value="15" label="satisfactory">satisfactory</option>
                  <option value="16" label="developing">developing</option>
                 
                </select>
              </li>
            </ul>
            <h5>In particular, {{ attendee.customer.firstname }} has:</h5>

            <ul class="list-unstyled">
              <li>
                <input
                  type="checkbox"
                  v-model="lor.overall1"
                  true-value="1"
                  false-value=""
                />
                demonstrated a keen interest in the topics covered on the course.
              </li>
              <li>
                <input
                  type="checkbox"
                  v-model="lor.overall2"
                  true-value="2"
                  false-value=""
                />
                developed a confident teaching style.
              </li>
              <li>
                <input
                  type="checkbox"
                  v-model="lor.overall3"
                  true-value="3"
                  false-value=""
                />
                shown the ability to establish rapport in the class.
              </li>
              <li>
                <input
                  type="checkbox"
                  v-model="lor.overall4"
                  true-value="4"
                  false-value=""
                />
                responded well to suggestions.
              </li>
            </ul>
            <hr>
            <h4>Comments</h4>
            <textarea
              style="width: 300px; height: 150px;"
              v-model="lor.comments"
              >{{ lor.comments }}</textarea
            ><br />
            <el-button type="primary" :loading="savingLor" @click="saveLOR()"
              >Save</el-button
            >
            <br />
                <p>
              <b>About TEFL Scotland</b>
          The TEFL Org trains thousands of students every year on courses ranging from 20 to 188 hours in length. We are accredited by ODLQC, BAC, TQUK (with Ofqal regulated courses offered) and are an SQA Approved Centre (Scottish Qualifications Authority). Should you require any further information about the courses or our organisation please get in touch.
            </p>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import gql from "graphql-tag";
import api from "./api";
import moment from "moment";
export default {
  data() {
    return {
      attendee: {},
      lor: {},
      savingLor: false,
      hasExistingLor: false
    };
  },
  methods: {
    getClassroomAttendee(id) {
      this.$apollo
        .query({
           fetchPolicy: 'no-cache',
          // desc_nulls_last filters out any null data
          query: gql`
        {
              ClassRoomAttendee_by_pk(id: "${id}") {
              classRoomId
              lorSourceUrl
              customer {
                  id
                firstname
                lastname
              }
            }
        }
        `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.attendee = response.data.ClassRoomAttendee_by_pk;
          //get any existing lor
          if (this.attendee.lorSourceUrl !== "") {
            this.hasExistingLor = true;
            this.getLOR();
          }
        });
    },

    getLOR() {
      this.$apollo
        .query({
          fetchPolicy: 'no-cache',
          // desc_nulls_last filters out any null data
          query: gql`
            query MyQuery($customerId: Int!) {
              LetterOfReference(where: { customerId: { _eq: $customerId } }) {
                believe
                comments
                customerId
                dateCreated
                dateUpdated
                demonstrated
                gender
                id
                learnt
                overall1
                overall2
                overall3
                overall4
                planning
                sourceUrl
                understanding
                support
                customer {
                  id
                  firstname
                  lastname
                  email
                }
              }
            }
          `,
          variables: {
            customerId: this.attendee.customer.id
          },
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.lor = response.data.LetterOfReference[0];
          //get any existing lor
        });
    },


    saveLOR() {
      //generate the pdf version to get the sourec url
      this.savingLor = true;
      const isOnline = false
      const createLORpdf = api.createLor({ ...this.attendee, ...this.lor,isOnline });
      Promise.resolve(createLORpdf).then(response => {
        //console.log(response.data)
        this.lor.lorSourceUrl = response.data;

        //console.log('lor: ',this.lor);
        let q;
        if (!this.hasExistingLor) {
          q = gql`
            mutation insert_lor($customerId: Int!,$attendeeId:Int!,$gender: String,$learnt: String, $overall1: String, $overall2: String, $overall3: String, $overall4: String, $planning: String, $support: String, $understanding: String,$demonstrated: String,$believe: String,$comments:String,$lorSourceUrl:String){

              insert_LetterOfReference(objects: {customerId: $customerId, gender: $gender, learnt: $learnt, overall1: $overall1, overall2: $overall2, overall3: $overall3, overall4: $overall4, planning: $planning, support: $support, understanding: $understanding,demonstrated:$demonstrated,believe:$believe,comments:$comments,sourceUrl:$lorSourceUrl,template:"standard"})
              {
                  returning{id}
              }
              update_ClassRoomAttendee(_set: {lorSourceUrl: $lorSourceUrl}, where: {id: {_eq: $attendeeId}}) {
                returning {
                  lorSourceUrl
                }
              }
        

          }
        `;
        } else {
          q = gql`
            mutation update_lor($customerId: Int!,$attendeeId:Int!,$gender: String,$learnt: String, $overall1: String, $overall2: String, $overall3: String, $overall4: String, $planning: String, $support: String, $understanding: String,$demonstrated: String,$believe: String,$comments:String,$lorSourceUrl:String){
              update_LetterOfReference(where: {customerId: {_eq: $customerId}}, _set: {believe: $believe, comments: $comments, dateUpdated: "${moment().format("YYYY-MM-DDThh:mm:ss")}", demonstrated: $demonstrated, gender: $gender, learnt: $learnt, overall1: $overall1, overall2: $overall2, overall3: $overall3, overall4: $overall4, planning: $planning, support: $support, understanding: $understanding}) {
                returning {
                  id
                }
              }
            }
          `;
        }
        this.$apollo
          .mutate({
            mutation: q,
            variables: {
              customerId: this.attendee.customer.id,
              gender: this.lor.gender,
              learnt: this.lor.learnt,
              overall1: this.lor.overall1 ? this.lor.overall1 : "",
              overall2: this.lor.overall2 ? this.lor.overall2 : "",
              overall3: this.lor.overall3 ? this.lor.overall3 : "",
              overall4: this.lor.overall4 ? this.lor.overall4 : "",
              planning: this.lor.planning,
              support: this.lor.support,
              lorSourceUrl:this.lor.lorSourceUrl,
              understanding: this.lor.understanding,
              demonstrated: this.lor.demonstrated,
              believe: this.lor.believe,
              comments: this.lor.comments,              
              attendeeId: this.$route.params.id
            }
          })
          .then(result => {
            //generate the pdf version
            this.savingLor = false;
            this.$notify({
              title: "Create Letter ",
              message: "New letter created",
              type: "success"
            });
            this.$router.push({ path: "/tutors/register/" +this.attendee.classRoomId });
          })
          .catch(error => {
            this.$notify({
              title: "Error message",
              message: error.message,
              type: "error"
            });
          });
      });
    }
  },
  mounted() {
    this.getClassroomAttendee(this.$route.params.id);
  },

  watch: {
    "$route.params.id": function(id) {
      this.getClassroomAttendee(id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Tutor/Lor.vue